<template>
  <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="mobilePhoneNum">
      <Input v-model="form.mobilePhoneNum" placeholder="请输入手机号码">
        <span slot="prepend">
          <Icon :size="16" type="ios-phone-portrait"></Icon>
        </span>
        <span slot="append">
          <Button @click="onMobileVerifyCodeClick">获取验证码</Button>
        </span>
      </Input>
    </FormItem>
    <FormItem prop="mobileVerifyCode">
      <Input v-model="form.mobileVerifyCode" placeholder="请输入短信验证码">
        <span slot="prepend">
          <Icon :size="14" type="md-lock"></Icon>
        </span>
      </Input>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form>
</template>
<script>
  import config from '@/config'
  import store from '@/store'

  export default {
    name: 'SmsLoginForm',
    props: {
      mobilePhoneNumRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '手机号码不能为空', trigger: 'blur' }
          ]
        }
      },
      mobileVerifyCodeRules: {
        type: Array,
        default: () => {
          return [
            { required: true, message: '短信验证码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    data () {
      return {
        getWebVerifyCodeUrl:'',
        form: {
          mobilePhoneNum: '',
          mobileVerifyCode: ''
        }
      }
    },
    computed: {
      rules () {
        return {
          mobilePhoneNum: this.mobilePhoneNumRules,
          mobileVerifyCode: this.mobileVerifyCodeRules
        }
      }
    },
    methods: {
      onMobileVerifyCodeClick(){
        store.dispatch('ClientAccountServ_GetLoginSMSVerifyCode', {
          params: {telephone:this.form.mobilePhoneNum},
          urlparams: null
        }).then(() => {

        }).catch(err => {
          this.$Message.error(err)
        })
      },
      handleSubmit () {
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$emit('on-success-valid', {
              mobilePhoneNum: this.form.mobilePhoneNum,
              mobileVerifyCode: this.form.mobileVerifyCode
            })
          }
        })
      }
    },
    mounted(){

    }
  }
</script>
